import { render, staticRenderFns } from "./PromotionsSearchBox.vue?vue&type=template&id=c226657e&"
import script from "./PromotionsSearchBox.vue?vue&type=script&lang=js&"
export * from "./PromotionsSearchBox.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsSearchBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports